import React from 'react';
import './Developer.css'
const Developer = (props) => {
    // console.log(props);
    const { name, img, org, designation, salary, skill, github } = props.developers;
    return (
        <div className='dev-cart'>
            <img src={img} alt="" />
            <div className='dev-cart-txt'>
                <h3>{name}</h3>
                <p>{designation}</p>
                <p>Organization: {org}</p>
                <p>Salary: ${salary}</p>
                <p>Expert in : {skill}</p>
                <p><a target='_blank' className='fa fa-brands fa-github' rel="noreferrer noopener" href={github}> Visite GitHub</a></p>
                <button onClick={() => { props.clickHandle(props.developers) }} className='btn fa fa-solid fa-user-plus'> Add Developer To List </button>
            </div>
        </div>
    );
};

export default Developer;